export const isMobileShareDevice = (navigatorObject) => {
  const userAgent = navigatorObject?.userAgent || "";
  return (
    /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent) ||
    (/Macintosh/i.test(userAgent) && navigatorObject?.maxTouchPoints > 1)
  );
};

export const createReportMailto = (reportUrl, reportLabel, bodyText) => {
  const title = reportLabel || "Dynamic Action Plan";
  const subject = encodeURIComponent(title);
  const body = encodeURIComponent(
    `${bodyText || `View the ${title}:`}\n\n${reportUrl}`,
  );
  return `mailto:?subject=${subject}&body=${body}`;
};

const SHARED_MOBILITY_REPORT_PATH = "/mobility-report-shared/";

/**
 * Public "Full Mobility Report" link for a patient summary, or "" when there
 * is no real one. Only the app's own public report page counts:
 *   - `report.slug`                          → {origin}/mobility-report-shared/{slug}
 *   - `report.url` = /mobility-report-shared/{slug} (relative or absolute)
 * Anything else (e.g. a placeholder URL) is dropped so a patient never lands
 * on a 404.
 */
export const resolveMobilityReportUrl = (report, origin) => {
  if (!report) return "";
  if (report.slug) {
    return `${origin}${SHARED_MOBILITY_REPORT_PATH}${encodeURIComponent(
      report.slug,
    )}`;
  }
  if (!report.url) return "";
  try {
    const url = new URL(report.url, origin);
    const slug = url.pathname.startsWith(SHARED_MOBILITY_REPORT_PATH)
      ? url.pathname.slice(SHARED_MOBILITY_REPORT_PATH.length)
      : "";
    return slug && !slug.includes("/") ? url.toString() : "";
  } catch (error) {
    return "";
  }
};
